import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CommonService } from 'src/services/common/common.service';
import { ServiceManagerService } from 'src/services/service-manager.service';
import { SocketService } from 'src/services/socket/socket.service';
import { SeoService } from 'src/services/seo/seo.service';
import { LanguageList } from 'src/constants/constant';
import { AppComponent } from '../app.component';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  chatExist: any = false;
  userExist: any = false;
  userList: any = [];
  showDetail: any = false;
  showLanguage: any = false;
  userId: any = '';
  currentPeer: any = {};
  selectedLanguage: any = {};
  chatStartClicked: any = false;
  apiLoaded: any = true;
  isServiceOpen: boolean = true;
  languageListener: any;
  intervalId: any;
  constructor(
    public app: AppComponent,
    public route: ActivatedRoute,
    public commonService: CommonService,
    private serviceManager: ServiceManagerService,
    private socketService: SocketService,
    private seoService: SeoService
  ) {
    this.initialize();
  }

  ngOnInit(): void {
    this.seoService.setMetaTags(
      'Outlive Suicide Prevention Chat, Online Peer Support Chat',
      'Connect with a peer supporter through Outlive suicide prevention chat. A confidential chat for suicidal thoughts and emotional distress whenever you need to talk.'
    );
    this.startPolling();
  }
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {
    this.stopPolling();
  }

  startPolling(): void {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        this.getAvailablePeers();
      }, 30000);
    }
  }

  stopPolling(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  /**
   * Initializes home component
   */
  async initialize() {
    this.getLanguage();
    this.userId = localStorage.getItem('userId');
    if (this.userId) {
      if (!(await this.commonService.checkChatExist())) {
        this.getAvailablePeers();
      } else {
        if (this.commonService.current.page == 'TRANSFER-HOME') {
          this.commonService.chatExist = true;
        }
      }
    } else {
      this.getAvailablePeers();
    }
  }

  /**
   * Ends chat
   */
  endChat() {
    this.commonService.chatEnded.next('home-chat-end');
  }

  /**
   * Gets available peers
   */
  getAvailablePeers() {
    this.userList = [];
    this.apiLoaded = false;
    var body = {
      user_type: 'Supporter',
    };
    this.serviceManager
      .CallBackendServiceAPI('get_peer_list', body)
      .subscribe((data: any) => {
        this.isServiceOpen = data['is_service_open'] ?? true;
        this.userList = data['users'];
        var availableClient = data['users'].map((user: any) => user.peerId);
        this.socketService.getAvailableClient(availableClient).then(() => {
          this.apiLoaded = true;
        });
      });
  }

  /**
   * Whether every currently online peer supporter is busy in another chat
   */
  allPeersBusy(): boolean {
    var onlinePeers = this.userList.filter((user: any) =>
      this.commonService.availableClient.includes(user.peerId)
    );
    return onlinePeers.length > 0 && onlinePeers.every((user: any) => user.is_busy);
  }

  /**
   * Shows details
   * @param index
   */
  showDetails(index: any) {
    if (this.commonService.current.status === 'CONNECTING') {
      return;
    }
    this.app.modal.show();
    this.commonService.selectedPeer = this.userList[index];
    this.commonService.current.status = 'SHOW-DETAILS';
  }

  /**
   * Navigate tp back
   */
  navBack() {
    this.showDetail = false;
  }

  /**
   * Shows chat
   */
  showChat() {
    if (this.app.modal.isShown()) {
      this.app.modal.hide();
    }
    this.commonService.showChat.next('home-show-chat');
  }

  /**
   * Gets language
   */
  getLanguage() {
    var language: any = localStorage.getItem('language') || 'en';
    this.selectedLanguage = LanguageList[language];
  }

  /**
   * Saves language
   */
  saveLanguage(option: any) {
    this.showLanguage = false;
    this.selectedLanguage = option;
    for (var language in LanguageList) {
      if (LanguageList[language] == this.selectedLanguage) {
        this.commonService.saveLanguage(language, '/home');
      }
    }
  }

  /**
   * Toggles language
   */
  toggleLanguage() {
    this.showLanguage = !this.showLanguage;
    if (!this.showLanguage) {
      this.removeLanguageListener();
    } else {
      this.languageListener = this.listenClick.bind(this);
      document
        .getElementById('home')
        ?.addEventListener('click', this.languageListener, true);
    }
  }

  /**
   * Listens click
   * If user not clicks the select option,  then hide the option list and remove listener
   * If user click option, then get the option and hide the option list and remove listener
   * If user click selected content, then hide the option list
   * @param e
   */
  listenClick(e: any) {
    if (
      !document.getElementById('language-container')?.contains(e?.target) &&
      !document.getElementById('language')?.contains(e?.target)
    ) {
      this.showLanguage = false;
      this.removeLanguageListener();
    } else if (
      document.getElementById('language-container')?.contains(e?.target) &&
      !document.getElementById('sep-line')?.contains(e?.target)
    ) {
      var language = e.target.innerText.trim();
      this.saveLanguage(language);
      this.showLanguage = false;
      this.removeLanguageListener();
    } else if (document.getElementById('language')?.contains(e?.target)) {
      this.showLanguage = true;
    }
  }

  /**
   * Removes language listener
   */
  removeLanguageListener() {
    document
      .getElementById('home')
      ?.removeEventListener('click', this.languageListener, true);
  }

  /**
   * Available language
   * @param languages
   * @returns
   */
  availableLanguage(languages: any) {
    return languages.filter((e: any) => e != this.selectedLanguage);
  }
}
